<template>
<div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "uxBase"
}
</script>

<style scoped>

</style>
